import(/* webpackMode: "eager", webpackExports: ["ResetPasswordView"] */ "/vercel/path0/src/domains/auth/components/view/reset-password-view.tsx");
